import Dexie, { DexieError } from "dexie"
import { REFRESH_INDEXED } from "./enums.enums"
import { HttpErrorResponse } from "@angular/common/http"

export const hasNavigatorMemory = async (data?: any): Promise<boolean> => {
  try {
    const oStorage = await navigator.storage.estimate();
    const sData = data ? JSON.stringify(data) : '';
    const nQuota = oStorage?.quota ?? 0;
    const nUsed = oStorage?.usage ?? 0;
    const nDataQuote = new TextEncoder().encode(sData).length;
    return (nUsed + nDataQuote) < (nQuota * 0.8);
  } catch(err) {
    errorHandler(err);
    return false; 
  }
}

export const errorHandler = (err: any): void => {
  if (err instanceof Dexie.DexieError) {
    console.log(err.cause, err.inner, err.message, err.stack);
    dexieErrors(err);
  } else if (err instanceof HttpErrorResponse) {
    console.log(err, 'HttpErrorResponse dexie');
  } else {
    console.log('Another error dexie');
  }
}

export const isMatchedData = (key: string | number | null, value: string | number | null): boolean => {
  return !key || key == value;
}

export const aId_DataToRefresh = (nRefreshID: REFRESH_INDEXED, data: any[]): any[] => {
  return data
    .filter(dataR => 'refresh' in dataR && dataR.refresh == nRefreshID)
    .map(dataR => dataR.id);
}

export const deleteDuplicated = (data: any[]): any[] => {
  return Array.from(new Set(data.map(v => JSON.stringify(v)))).map(v => JSON.parse(v));
}

const dexieErrors = (error: DexieError): void => {
  console.log(`DEXIE ${error.name ?? 'Error desconocido'}: `, error);
}